import React from 'react';
import PropTypes from 'prop-types';

const Truncate = props => {
    const { content, targetLength, className } = props;
    const valid = typeof content === 'string' && typeof targetLength === 'number';

    const truncate = (content, target) => {
        let inTag = false;
        let index = 0;
        let letterCount = 0;
        let tag = '';
        let tagOpen = false;
        let closingTag = /<.*\/\w*>|<br>/;
        let tagFirstCharacter = /[/a-zA-Z]/;

        content.split('').some((el, i, a) => {
            if (!tagOpen && letterCount >= target && el === ' ') {
                // tag is not open and target has been met END
                return true;
            }

            if (el === '<' && content[i + 1].match(tagFirstCharacter)) {
                tagOpen = true;
                inTag = true;
            }

            if (inTag) {
                tag = tag + el;
            }

            if (!inTag) {
                letterCount = letterCount + 1;
            }

            index = index + 1;

            if (el === '>') {
                inTag = false;

                if (tag.match(closingTag)) {
                    tagOpen = false;

                    //if a closing tag was just completed and target has been met, END
                    if (letterCount >= target) {
                        return true;
                    }
                }
            }

            return false;
        });

        return `${content.substring(0, index)}${index < content.length - 1 ? '…' : ''}`;
    };

    return valid ? (
        <div
            className={className}
            dangerouslySetInnerHTML={{
                __html: truncate(content, targetLength)
            }}
        />
    ) : null;
};

Truncate.propTypes = {
    content: PropTypes.string.isRequired,
    targetLength: PropTypes.number.isRequired,
    className: PropTypes.string
};

export default Truncate;
